module.exports = __webpack_public_path__ + "static/SuperMakersLogo-64b90fa18e693ab77ddc2f5430ae08a3.png";